/* CWR 1.2 — Home header: the studio's name (retire-greeting-header). Uses the injected client-theme
   tokens (active under :root[data-client-theme], set by ClientShell). Fonts are
   the global self-hosted faces from CWR 0.4. */

/* ── Name header ───────────────────────────────────────────────────────── */
.logoHeader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}

/* The studio's name fills the room under Telegram's chrome row (Gabriel 2026-11-03: "there is plenty of room there to
   make it bigger") and always stays on one line (Gabriel 2026-11-03: "it should always stay on one line"): a name too
   long for 32px is drawn smaller to fit (ClientNameHeader sets the size). */
.wordmark {
  font-family: var(--client-font-heading, 'EB Garamond', Georgia, serif);
  font-weight: 600;
  font-size: 32px;
  letter-spacing: 0;
  line-height: 1.1;
  color: var(--text-primary, #faf3e8);
  text-align: center;
  white-space: nowrap;
}

/* Descriptor under the text wordmark: same treatment as the logo lockup's line. */
.descriptor {
  margin-top: 6px;
  font-family: var(--client-font-body, 'Outfit', system-ui, sans-serif);
  font-size: 10px;
  font-weight: 500;
  line-height: 1;
  letter-spacing: 3.5px;
  text-transform: uppercase;
  color: var(--accent-deep);
  text-align: center;
}
